import { render, staticRenderFns } from "./TicketsChat.vue?vue&type=template&id=1067aad2&scoped=true"
import script from "./TicketsChat.vue?vue&type=script&lang=js"
export * from "./TicketsChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067aad2",
  null
  
)

export default component.exports